















import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api';
import { windowHelper } from '@tencent/ppd-base-libs';
import { LanuchWeapp } from '@tencent/wphk-components-launch-weapp';
import Button from '@/components/common/button.vue';
import { JumpInfo } from '@/types/task';
import { IconType, showToast } from '@tencent/wphk-act-base-ui';
import { i18n } from '@/i18n';

export default defineComponent({
  name: 'TaskJumpBtn',
  props: {
    /** 跳转信息 */
    jumpInfo: {
      type: Object as PropType<JumpInfo>,
      required: true,
    },
    /** 跳转之前执行方法 */
    beforeJump: {
      type: Function as PropType<() => Promise<void>>,
      require: false,
      default: () => async () => { },
    },
  },
  components: {
    Button,
    LanuchWeapp,
  },
  setup(props) {
    const { beforeJump } = toRefs(props);
    const info = computed(() => {
      if (props.jumpInfo.mode === 'mp') {
        // @ts-ignore
        if (/^gh_/.test(props.jumpInfo.username)) {
          return {
            appid: '',
            // @ts-ignore
            username: props.jumpInfo.username,
          };
        }
        return {
          // @ts-ignore
          appid: props.jumpInfo.username,
          username: '',
        };
      }
      return {
        appid: '',
        username: '',
      };
    });

    return {
      info,
      async onClickJumpH5(url: string) {
        if (beforeJump.value) {
          await beforeJump.value();
        }
        console.log('跳转地址：', url);
        // 跳轉
        showToast({
          title: i18n('跳轉中...'),
          duration: 1000,
          icon: IconType.loading,
        });
        windowHelper.redirect(url, 300);
      },
    };
  },
});
